import { ID, RoleOption, Roles } from '@griply/types';

export const withRoles = <Data extends object>(
  data: Data,
  userId: ID,
): Data & { roles: Roles } => ({
  ...data,
  roles: {
    [RoleOption.Owner]: userId,
    [RoleOption.All]: [userId],
  },
});
